define(['text!./templates/button-select-typekey.html'],
    (templateStr) => {

        return [function () {
            return {
                restrict: 'E',
                template: templateStr,
                scope: {
                    /** Model (value) to select. */
                    model: '=',
                    /** Should the button select be disabled ? */
                    disabledIf: '=?',
                },
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/ButtonSelectTypekey.js